<template>
  <div class="module-banner img-cover" :style="aStyle">
    <div
      class="swiper-module"
      :style="{
        top: `${$unit(imageValue.top)}`
      }"
    >
      <swiper class="swiper" :options="modelObj.tranform" ref="mcBanner">
        <swiper-slide v-for="pic in list" :key="pic.id"
          ><img :src="pic.image"
        /></swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
export default {
  name: 'McBanner',
  props: {
    imageValue: {
      type: Object,
      default: () => {}
    },
    list: {
      type: Array,
      default: () => []
    },
    styles: {
      type: Object,
      default: () => {}
    },
    attrs: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      height: 793,
      defaultImage:
        'https://yxfile.3k.com/2023/02/24/upload_s2ejtnaew9pbpjxop0rbn83k7nqfgwb8.jpg',
      show: true,
      mAttrs: {},
      modelObj: {
        tranform: {
          effect: 'coverflow',
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: 'auto',
          coverflowEffect: {
            rotate: 20,
            stretch: 30,
            depth: 100,
            modifier: 1.5,
            slideShadows: true
          },
          autoplay: true,
          loop: true
        }
      }
    };
  },
  watch: {
    imageValue() {
      this.init();
    },
    attrs: {
      handler(newValue) {
        this.mAttrs = {
          ...this.attrs,
          ...this.modelObj['tranform'],
          ...newValue
        };
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    aStyle() {
      return {
        height: this.$unit(this.height),
        backgroundImage: `url(${
          this.imageValue.imagePath || this.defaultImage
        })`
      };
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let img = new Image();
      img.onload = () => {
        let h = img.height;
        this.height = h;
      };
      img.src = this.imageValue.imagePath;
    }
  }
};
</script>

<style lang="scss" scoped>
.img-cover {
  background-repeat: no-repeat;
  background-size: cover;
}
.module-banner {
  position: relative;
  width: 100%;
}
.swiper-module {
  position: absolute;
  left: 10%;
  top: 180px;
  width: 80%;
  height: 556px;
  z-index: 499;
}
.swiper {
  .swiper-slide {
    width: 313px;
    height: 556px;
    img {
      width: 100%;
      display: block;
    }
  }
}
</style>
